import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  box: {
    padding: 15,
    background: 'white',
    maxWidth: 800,
  },
  mainTitle: {
    color: '#16496E',
    textTransform: 'uppercase'
  },
  title: {
    color: '#16496E'
  },
  table: {},
  tableCell: {
    padding: 5
  }
}))
